import merge from 'deepmerge'
import PropTypes from 'prop-types'
import React from 'react'

const shapeStyle = {
  fill: 'none',
  stroke: '#8e8e90',
  strokeLinecap: 'round',
  strokeWidth: 1
}

const baseStyles = {
  circle: { ...shapeStyle },
  polyline: { ...shapeStyle }
}

const Timezone = ({ styles = {}, ...props }) => {
  const merged = merge(baseStyles, styles)
  return (
    <svg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle style={merged.circle} cx='10' cy='10' r='9' />
      <polyline style={merged.polyline} points='10,6 10,10 13,13' />
    </svg>
  )
}

Timezone.propTypes = {
  styles: PropTypes.object
}

export default Timezone
